module.exports = __webpack_public_path__ + "img/1.ef3c6ca3.png";